"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { title: "Moon habitat, logistics, and mining rates" };
const _hoisted_2 = {
    key: 0,
    class: "global_params_value"
};
const _hoisted_3 = ["alt", "title"];
const _hoisted_4 = {
    key: 1,
    class: "moon_params_value"
};
const _hoisted_5 = { class: "habitat" };
const _hoisted_6 = { class: "logistics" };
const _hoisted_7 = { class: "mining" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        _cache[0] || (_cache[0] = (0, vue_1.createElementVNode)("div", { class: "moon-tile" }, null, -1)),
        (0, vue_1.createElementVNode)("div", null, [
            (_ctx.isMax)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                    (0, vue_1.createElementVNode)("img", {
                        src: "assets/misc/checkmark.png",
                        class: "checkmark",
                        alt: _ctx.$t('Completed!'),
                        title: _ctx.$t('Completed!'),
                        "data-test": "completed-checkmark"
                    }, null, 8, _hoisted_3)
                ]))
                : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, [
                    (0, vue_1.createElementVNode)("span", _hoisted_5, (0, vue_1.toDisplayString)(_ctx.moonData.habitatRate), 1),
                    (0, vue_1.createElementVNode)("span", _hoisted_6, (0, vue_1.toDisplayString)(_ctx.moonData.logisticsRate), 1),
                    (0, vue_1.createElementVNode)("span", _hoisted_7, (0, vue_1.toDisplayString)(_ctx.moonData.miningRate), 1)
                ]))
        ])
    ])), [
        [_directive_i18n]
    ]);
}
